import { Link } from "react-router-dom";

import thumbnailMap from "../../public/fps2026.png";
import paperPdf from "../../public/FPS2026.pdf";

const PAPER_PDF_URL = paperPdf;

function PublicationsMobile() {
  return (
    <section id="blog" className="pt-[95px]">
      <div className="container items-start">
        <div className="flex items-center">
          <p className="text-xl font-bold mb-4">PUBLICATIONS</p>
        </div>

        <div className="flex flex-col gap-6">
          <div className="w-[280px] h-[140px] bg-white overflow-hidden rounded-md mt-2">
            <img
              src={thumbnailMap}
              alt="thumbnail"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="mb-4 flex flex-col gap-2">
            <p className="font-medium text-[18px]">
              On the Security of Agentic Pull Requests in GitHub: An Empirical
              Study{" "}
              <a href={PAPER_PDF_URL} target="_blank" rel="noopener noreferrer">
                <span className="font-[300] text-custom-green whitespace-nowrap">
                  <span className="text-[20px]">[</span>
                  <a className="underline underline-offset-2">PDF</a>
                  <span className="text-[20px]">]</span>
                </span>
              </a>
            </p>
            <p className="">
              <span className="font-medium">Minh Le, </span>
              <span className="text-gray-4">
                Thanoshan Vijayanand, Gouri Ginde, Benjamin Tan, Lorenzo De
                Carli
              </span>
            </p>
            <div className="text-gray-4">
              FPS 2026 - 19th International Symposium on Foundations & Practice
              of Security
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PublicationsMobile;
